import Page from "./page"
import Blog from "./blog"
import ComponentNotFound from "./component-not-found"
import TwoColsText from "./two-cols-text"
import TwoCols from "./two-cols"
import OneCol from "./one-col"
import CallToActionArea from "./call-to-action-area"
import SmallBlogTeasers from "./small-blog-teasers"
import SmallBlogTeaser from "./small-blog-teaser"
import BigBlogTeasers from "./big-blog-teasers"
import BigBlogTeaser from "./big-blog-teaser"
import BlogListing from "./blog-listing"
import Slider from "./slider"
import Slide from "./slide"
import FullWidthSlide from "./fullwidth-slide"
import ImageWithTeaserBox from "./image-with-teaser-box"
import PieChart from "./pie-chart"
import PageTeasers from "./page-teasers"
import PageTeaser from "./page-teaser"
import ContentpageTwoColumn from "./contentpage-two-column"
import Locations from "./locations"
import LocationTeaser from "./location-teaser"
import ContentPageTeaser from "./contentpage-teaser"
import Headline from "./headline"
import Quote from "./quote"
import SpecialHeader from "./special-header"
import Form from "./form"
import Input from "./input"
import Textarea from "./textarea"
import Select from "./select"
import LocationSelect from "./location-select"
import Checkbox from "./checkbox"
import Radiobutton from "./radiobutton"
import FieldGroup from "./field-group"
import InputTable from "./input-table"
import Captcha from "./captcha"
import FormDetails from "./form-details"
import FormInfo from "./form-info"
import FormSubmit from "./form-submit"
import Steps from "./steps"
import Step from "./step"
import AlternativeBackground from "./alternative-background"
import LogoGallery from "./logo-gallery"
import LogoGalleryItem from "./logo-gallery-item"
import PageOverview from "./page-overview"
import GlobalForm from "./global-form"
import GlobalComponent from "./global-component"
import BIteTool from "./b-ite-tool"
import ThreeColumnText from "./three-cols-text"
import PharmaMailchimp from "./pharma-mailchimp"
import Video from "./video"

const ComponentList = {
  page: Page,
  formPage: Page,
  blog: Blog,
  globalForm: GlobalForm,
  globalComponent: GlobalComponent,
  twoColsText: TwoColsText,
  twoCols: TwoCols,
  oneCol: OneCol,
  callToActionArea: CallToActionArea,
  smallBlogTeasers: SmallBlogTeasers,
  smallBlogTeaser: SmallBlogTeaser,
  bigBlogTeasers: BigBlogTeasers,
  bigBlogTeaser: BigBlogTeaser,
  bigPageTeaser: BigBlogTeaser,
  pageOverview: PageOverview,
  blogListing: BlogListing,
  slider: Slider,
  slide: Slide,
  fullWidthSlide: FullWidthSlide,
  imageWithTeaserBox: ImageWithTeaserBox,
  pieChart: PieChart,
  pageTeasers: PageTeasers,
  pageTeaser: PageTeaser,
  contentpageTwoColumn: ContentpageTwoColumn,
  locations: Locations,
  locationTeaser: LocationTeaser,
  contentPageTeaser: ContentPageTeaser,
  headline: Headline,
  quote: Quote,
  specialHeader: SpecialHeader,
  form: Form,
  formInfo: FormInfo,
  formSubmit: FormSubmit,
  input: Input,
  textarea: Textarea,
  select: Select,
  locationSelect: LocationSelect,
  checkbox: Checkbox,
  radiobutton: Radiobutton,
  fieldGroup: FieldGroup,
  inputTable: InputTable,
  captcha: Captcha,
  formDetails: FormDetails,
  step: Step,
  steps: Steps,
  alternativeBackground: AlternativeBackground,
  logoGallery: LogoGallery,
  logoGalleryItem: LogoGalleryItem,
  bIteTool: BIteTool,
  threeColumnText: ThreeColumnText,
  pharmaMailchimp: PharmaMailchimp,
  video: Video,
}

const Components = type => {
  if (typeof ComponentList[type] === "undefined") {
    return ComponentNotFound
  }
  return ComponentList[type]
}

export default Components
